export enum LandingRouteName {
  LandingError = 'home-landing-error',
  DefaultLanding = 'home-default-landing',
}
